import React, { useState, useEffect } from 'react';
import back from "~/assets/images/arrow.svg";
import HeaderDesktop from "~/components/layout/Header";
import Card from "~/components/layout/Card";
import VisitCard from "~/components/layout/Card/Visit";
import Modal from "react-bootstrap/Modal";
import close from '~/assets/images/close.png';
import DesktopItem from '~/components/pages/Consultant/ItemDesktop';
import MobileItem from '~/components/pages/Consultant/ItemMobile';
import SideBar from "~/components/layout/Sidebar";
import api from '~/services/api';
import { analytics, logEvent }  from "~/services/firebaseConfig";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import HeaderMobile from '~/components/layout/HeaderOld';
import RatingModal from '~/pages/Rating';
import Rating from '@material-ui/lab/Rating';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import { mask } from '~/utils/formatters/phoneFormatter';
import {
  BackIcon,
  Content,
  DivisionChangeName,
  HeaderContainer,
  HeaderMobileContainer,
  PageContainer,
  ContainerTitle,
  ContentImage,
  TitleInfo,
  ContainerAvaliation,
  StarDivision,
  DivisionCards,
  ContainerVisit,
  ContentVisit,
  WrapperVisitTable,
  PageTitleContainer,
  PageTitleItem,
  PageTitleVisit,
  VisitMessage,
  VisitContainer,
  DesktopWrapper,
  MobileWrapper,
  NextPageContainer,
  NextPage,
  CloseIcon,
  LabelTitleModal,
  StatusArea,
  ObjectiveArea,
  CommentArea,
  Legend,
  ItemDetails,
  SelectLabel,
  Icon,
  LabelModal,
  ContentModal
} from './styles';

export default function GasVoucherValidation() {
  const history = useHistory();

  const [loadingSave, setLoadingSave] = useState(true);
  const [loadingTable, setTable] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [offset, setOffset] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [avaliationDone, setAvaliationDone] = useState(false);
  const [resetAvaliation, setResetAvaliation] = useState(false);
  const [valueRating, setValueRating] = useState(0);
  const [valueComment, setValueComment] = useState('');
  const [loadingNext, setLoadingNext] = useState(false);
  const [notNext, setNotNext] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [options, setOptions] = useState([""]);
  const [selected, setSelected] = useState('');
  const [text, setText] = useState("");
  const [dataModal, setDataModal] = useState({
    code: '',
    status: '',
    object: '',
    comment: ''
  })
  const [visitsData, setVisitsData] = useState([])

  const stores = useSelector((state) => state.economicGroupReducer.stores);
  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );

  useEffect(() => {
    getRating();
  }, [economicGroupReducer.selectedStore, resetAvaliation]);

  function getRating() {
    setLoadingSave(true)
    const headerRating = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: 'GET',
      headers: headerRating,
    };

    let url = '/rating/v1/ratings';
    api.get(url + `?user-id=${localStorage.getItem("userId")}&department=COMMERCIAL_CONSULTANT&_limit=1000`, parameters)
    .then((res) => {
      if(res.data.length > 0) {
        let arrayConsultant = [];
        res.data.map((element) => {
          if(element.department === "COMMERCIAL_CONSULTANT") {
            arrayConsultant.push(element);
          }
          return null;
        });
        setAvaliationDone(true);
        setValueRating(arrayConsultant[arrayConsultant.length - 1].rating);
        setValueComment(arrayConsultant[arrayConsultant.length - 1].justification);
      }
      setLoadingSave(false);
    })
    .catch((err) => {
      toast.error("Ocorreu algum erro ao tentar buscar a avaliação, tente novamente!");
      setLoadingSave(false);
    })
  }

  async function getSobjectSfCase() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    let url = '/industrial/case/v1';
    await api.get(`${url}/cases-sf/sobject-technical-visit`, parameters)
    .then((res) => {
      const fields = res.data.fields;
      let sobjects = [];
      if (fields.length) {
        const fieldsValids = sobjects.concat(fields.map(function (field) {
          if ( field.name === "Tipo_de_Compromisso__c" && field.picklistValues.length){
            const picklists = field.picklistValues.filter((item) => item.active === true);
            return picklists.map(function (item) {
              return {value: item.value, label: item.label};
            })
          }
        }));
        let optionsSelected = []
        for (var i=0; i<fieldsValids.length; i+=1) {
          if (fieldsValids[i] && fieldsValids[i].length) {
            optionsSelected = optionsSelected.concat(fieldsValids[i]);
          }
        }
        setOptions(optionsSelected);
      } else {
        toast.error("Não foi possível buscar os assuntos, tente novamente!");
      }
    })
    .catch((err) => {
      toast.error("Ocorreu algum erro ao tentar buscar os assuntos de visita, tente novamente!");
    })
  }

  useEffect(() => {
    const fecthSobject = async () => {
      await getSobjectSfCase();
    }
    fecthSobject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function sendSfCase() {
    setLoadingButton(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    if (selected !== '') {
      const data = {
        contaId: localStorage.getItem("storeId"),
        contatoId: localStorage.getItem("contactIdSf"),
        tipoRegistro: "Solicitação de Visita Comercial - Parceiro",
        assunto: selected,
        detalhamento: text,
        fase: "Em Análise",
        origem: "MAP",
        status: "Aberto"
      }

      let url = '/industrial/case/v1';
      await api.post(`${url}/cases-sf/technical-visit`, data, parameters)
      .then((res) => {
        setLoadingButton(false);
        setSelected([]);
        setText("");
        setTable(true);
        getSfCase();
        toast.success("Sua solicitaçao foi realizada com sucesso. Seu consultor comercial avaliará a disponibilidade. Acompanhe o retorno.");
      })
      .catch((err) => {
        setLoadingButton(false);
        toast.error("Ocorreu algum erro ao criar solicitação, tente novamente!");
      })
    }
  }

  async function getSfCase(offsetParam=1) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    var date = new Date();
    date.setDate(date.getDate() + 1);
    const data = {
      "inicio": "2021-01-01",
      "termino": date.toJSON().slice(0,10),
      "pagina": notNext ? offset : offsetParam,
      "contaId": localStorage.getItem("storeId"),
      "tipoRegistro": "Solicitação de Visita Comercial - Parceiro",
    }

    let url = '/industrial/case/v1';
    await api.post(`${url}/cases-sf/filter-technical-visit`, data, parameters)
    .then((res) => {
      const visitsData = res.data;
      const visitsPayload = visitsData.resultado.map(function(item){
        return {
          code: item?.nomeCaso ? item.nomeCaso : null,
          status: item?.fase ? item.fase : null,
          date: item?.dataFinal ?  item.dataFinal : null,
          schedule: item?.horarioFinal ? item.horarioFinal : null,
          object: item?.assunto ? item.assunto : null,
          comment: item?.detalhamento ? item.detalhamento : null
        }
      })
      setNotNext( visitsData.resumo.totalPaginas > 1 ? false : true)
      setVisitsData(visitsPayload);
      setTable(false)
    })
    .catch((err) => {
      if (err.response.data.resultado.mensagem === "Nenhum caso encontrado."){
        setTable(false)
      } else {
        toast.error("Ocorreu algum erro ao listar solicitações, tente novamente!");
        setTable(false)
      }
    })
  }

  useEffect(() => {
    const fecthSfCases = async () => {
      await getSfCase();
    }
    fecthSfCases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleOpenModal(item) {
    setDataModal(item)
    setOpenModal(!openModal);
  }

  const nextPage = () => {
    logEvent(analytics, 'carregar_mais_solicitações_de_visitas');
    getSfCase(offset + 1);
    setOffset(offset + 1);
    setLoadingNext(true);
  };

  return(
    <PageContainer>
      <SideBar menuSelected={"Minha Conta"}>
        <DivisionChangeName>
          <HeaderContainer>
            <HeaderDesktop
              stores={stores}
            />
          </HeaderContainer>
          <HeaderMobileContainer>
            <HeaderMobile />
          </HeaderMobileContainer>
          <Content>
            <BackIcon>
              <img
                src={back}
                alt="Ícone para voltar"
                onClick={() => {
                  history.push('/minha-conta');
                }}
              />
            </BackIcon>
            {
              loadingSave ? (
                <Loading />
              ) : (
                <>
                  <RatingModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    isConsultant={true}
                    isEditable={avaliationDone}
                    valueRating={valueRating}
                    valueComment={valueComment}
                    resetAvaliation={resetAvaliation}
                    setResetAvaliation={setResetAvaliation}
                  />
                  <DivisionCards>
                    <div>
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}>
                        <ContainerTitle>
                          <ContentImage>
                            <img src={`${localStorage.getItem('consultantPhoto')}`} />
                          </ContentImage>
                          <TitleInfo>
                            <div>
                              <h4>Nome: </h4><span>{localStorage.getItem('consultantName')}</span>
                            </div>
                            <div>
                              <h4>Email: </h4><span><a href={`mailto:${localStorage.getItem('consultantEmail')}`}>{localStorage.getItem('consultantEmail')}</a></span>
                            </div>
                            <div>
                              {localStorage.getItem('consultantPhone') ? (
                                <>
                                  <h4>Celular: </h4>
                                  <span>
                                    <a href={`tel:${localStorage.getItem('consultantPhone')}`}>{mask(localStorage.getItem('consultantPhone'))}</a>
                                  </span>
                                </>
                              ) : null}
                            </div>
                          </TitleInfo>
                        </ContainerTitle>
                      </div>
                      <ContainerAvaliation>
                        {
                          avaliationDone && (
                            <>
                              <h4>Sua avaliação: </h4>
                              <StarDivision>
                                <Rating
                                  name="simple-controlled"
                                  value={valueRating}
                                  size="large"
                                  readOnly={true}
                                />
                                <p>{valueComment}</p>
                              </StarDivision>
                            </>
                          )
                        }
                        <a onClick={() => setShowModal(!showModal)}>
                          {
                            avaliationDone ? "Edite sua avaliação" : "Faça sua avaliação"
                          }
                        </a>
                      </ContainerAvaliation>
                    </div>
                    <Card
                      icon="mapa.svg"
                      title="Solicitar visita comercial"
                      component={
                        <VisitCard
                          options={options}
                          selected={selected}
                          setSelected={setSelected}
                          text={text}
                          setText={setText}
                          sendSfCase={sendSfCase}
                          loading={loadingButton}
                        />
                      }
                    />
                  </DivisionCards>
                  <ContainerVisit>
                    <ContentVisit>
                      <WrapperVisitTable>
                        <PageTitleContainer>
                          <PageTitleItem>
                            <PageTitleVisit>Minhas solicitações de visita:</PageTitleVisit>
                          </PageTitleItem>
                        </PageTitleContainer>
                        {loadingTable ? (
                          <Loading />
                        ) : (
                          <>
                            {visitsData.length < 1 ? (
                              <VisitMessage>
                                <span>Nenhuma solicitação encontrada</span>
                              </VisitMessage>
                            ) : (
                              <VisitContainer>
                                <DesktopWrapper>
                                  {visitsData.map((visits, index) => {
                                    return (
                                      <DesktopItem
                                        options={options}
                                        data={visits}
                                        key={index}
                                        openModal={() => handleOpenModal(visits)}
                                      />
                                    );
                                  })}
                                </DesktopWrapper>
                                <MobileWrapper>
                                  {visitsData.map((visits, index) => (
                                    <MobileItem
                                      options={options}
                                      data={visits}
                                      key={index}
                                      openModal={() => handleOpenModal(visits)}
                                    />
                                  ))}
                                </MobileWrapper>
                                <NextPageContainer content="center">
                                  {notNext ? null : (
                                    <NextPage onClick={() => nextPage()}>
                                      {loadingNext ? (
                                        <i
                                          className="fa fa-spinner fa-pulse fa-3x fa-fw"
                                          style={{
                                            fontSize: '16px',
                                            color: '#000FFF',
                                          }}
                                        />
                                      ) : (
                                        'Carregar mais...'
                                      )}
                                    </NextPage>
                                  )}
                                </NextPageContainer>
                              </VisitContainer>
                            )}
                            <Modal
                              show={openModal}
                              onHide={() => {
                                setOpenModal(false);
                              }}
                              className="modal-cancel"
                              centered
                            >
                              <Modal.Body style={{ padding: ".5rem", borderRadius: 10 }}>
                                <CloseIcon>
                                  <img
                                    src={close}
                                    alt="Ícone de fechar"
                                    onClick={() => {
                                      setOpenModal(false);
                                    }}
                                  />
                                </CloseIcon>
                                  <ContentModal>
                                    <LabelModal>
                                        <Icon
                                          src={'./assets/images/icons/mapa-black.svg'}
                                        />
                                      <LabelTitleModal>
                                        Detalhes de solicitação de visita comercial
                                      </LabelTitleModal>
                                    </LabelModal>
                                    <StatusArea>
                                      <Legend>
                                        Solicitação <u>{dataModal.code}</u>
                                      </Legend>
                                      <ItemDetails>
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          color:
                                          dataModal.status === "Aceita"
                                              ? "#75B943"
                                              : dataModal.status === "Negada"
                                              ? "#e34e2a"
                                              : dataModal.status === "Em Análise"
                                              ? "#f0b01b"
                                              : "#000",
                                        }}
                                        className="mdi mdi-checkbox-blank-circle mr-1"
                                      />
                                      {dataModal.status}
                                      </ItemDetails>
                                    </StatusArea>
                                    <ObjectiveArea>
                                        <SelectLabel>
                                          Assunto principal: &nbsp; &nbsp; {(options && dataModal.object) ? (options.find((item) => item.value === dataModal.object)?.label || dataModal.object ) : dataModal.object }
                                        </SelectLabel>
                                    </ObjectiveArea>
                                    <CommentArea>
                                        <SelectLabel>
                                          Comentário: &nbsp; &nbsp; {dataModal.comment}
                                        </SelectLabel>
                                    </CommentArea>
                                  </ContentModal>
                              </Modal.Body>
                            </Modal>
                          </>
                        )}
                      </WrapperVisitTable>
                    </ContentVisit>
                  </ContainerVisit>
                </>
              )
            }
          </Content>
        </DivisionChangeName>
        <OpenChatBot />
      </SideBar>
    </PageContainer>
  );
}
